module.exports = __webpack_public_path__ + "static/img/biaozhun_2.c5e50a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/officeImg/index/biaozhun_2.png
// module id = D8Be
// module chunks = 1